import { computed } from 'vue'

import { usePreferencesStore } from '@/contexts/preferences/stores/Preferences.store'
import { getPreference } from '@/contexts/preferences/Preferences.services'
import { PreferenceType } from '@/contexts/preferences/Preferences.interfaces'
import { PREFERENCE_KEYS } from '@/contexts/preferences/Preferences.constants'

export const useActionReviewPreference = () => {
  const preferencesStore = usePreferencesStore()

  const hasActionReviewPreference = computed(() => preferencesStore.getPreference(PREFERENCE_KEYS.ACTION_REVIEW))

  const fetchActionReviewPreference = async () => {
    const response = await getPreference(PREFERENCE_KEYS.ACTION_REVIEW, PreferenceType.BOOLEAN)
    preferencesStore.setPreference(PREFERENCE_KEYS.ACTION_REVIEW, response.ok ? response.data : null)
  }

  return {
    hasActionReviewPreference,
    fetchActionReviewPreference,
  }
}
